// src/services/FlashSalesServices.js
import api from "../api/api";

export const FlashSalesServices = {
  getFlashSales: async (onlyRunning = false) => {
    const res = await api.get("/flash-sales", {
      params: onlyRunning ? { only_running: 1 } : {},
    });

    const list = Array.isArray(res?.data?.data) ? res.data.data : [];

    return {
      status: true,
      data: list,
    };
  },
};